import React, {Component} from "react";
import {Field, reduxForm, formValueSelector} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";
import FormFieldsTable from "../../components/forms/FormFieldsTable";
import DropDownInputField from "../../components/forms/DropDownInputField";
import {connect} from "react-redux";
import FormError from "../../components/forms/FormError";

class RequestShippingQuoteForm extends Component {

  render() {
    let {errors, handleSubmit, submit, courierServices, submitting, courierService} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 

    let description = null;
    if (courierService) {
      let foundService = courierServices.find(x => x.get("service") === courierService);
      if (foundService) {
        description = foundService.get("description");
      }
    }

    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field 
              label="Courier Service"
              name="courierService"
              component={DropDownInputField}
              data={courierServices}
              valueKey="service"  
              titleKey="name" 
              showBlank={false}
              serverError={this.props.errors.courierService}
              />
          </FormFieldsTable>
          <p>{description}</p>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "RequestShippingQuoteForm"
})(RequestShippingQuoteForm);

const selector = formValueSelector("RequestShippingQuoteForm");
export default connect(state => {
  return {
    courierService: selector(state, "courierService")
  }
})(ReduxForm);